import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { ReactNode } from "react";

export default function AppPortal({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  const portalElement = document.querySelector("#app-portal");
  if (!portalElement) return null;

  return createPortal(children, portalElement);
}
